module.exports = __webpack_public_path__ + "img/connect-1-zh.952b12a3.png";